import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject, catchError, EMPTY, tap, Subject } from 'rxjs';

import { environment } from '@environments/environment';
import { handleError } from '@shared-functions/handle-error.function';

import { LogoEntidad } from '../interfaces/entidad-logo.interface';
import { UploadImageResponse } from '../interfaces/upload-image-response.interface';
import { WebSocketService } from '@core-services/websocket.service';

@Injectable({
  providedIn: 'root',
})
export class EntidadLogoService {
  private API_SERVER = environment.API_SERVER;

  private entidadLogosSubject = new ReplaySubject<LogoEntidad[] | []>(1);
  logos$ = this.entidadLogosSubject.asObservable();

  private logoActualizadoSource = new Subject<void>();
  logoActualizado$ = this.logoActualizadoSource.asObservable();

  private logoSistemaSubject = new BehaviorSubject<string>('');
  logoSistema$ = this.logoSistemaSubject.asObservable();

  constructor(private http: HttpClient) {}

  getLogosPorEntidad(): Observable<LogoEntidad[]> {
    return this.http.get<LogoEntidad[]>(`${this.API_SERVER}/entity/logos/`).pipe(
      tap((logos) => {
        console.log('data_logos', logos);
        this.entidadLogosSubject.next(logos);
      }),

      catchError(handleError),
    );
  }

  uploadLogo(
    entidadId: number,
    posicion: string,
    codigo: string,
    formData: FormData,
  ): Observable<UploadImageResponse> {
    return this.http
      .put<UploadImageResponse>(
        `${this.API_SERVER}/entity/${entidadId}/logo/${posicion}/codigo/${codigo}`,
        formData,
      )
      .pipe(catchError(handleError));
  }

  actualizarLogoSistemaDesdeDatos(logos: LogoEntidad[]): void {
    const logoSistema = logos.find((logo) => logo.posicion === 'logo_sistema');
    if (logoSistema) {
      const fullUrl = `${this.API_SERVER}/${logoSistema.path}?t=${Date.now()}`;
      this.logoSistemaSubject.next(fullUrl);
    }
  }

  clearLogos(): void {
    this.entidadLogosSubject.next([]);
    this.logoSistemaSubject.next('');
  }
}
